module.exports = __webpack_public_path__ + "img/img (41).c566987a.jpg";